import { render, staticRenderFns } from "./PageCreateEdit.vue?vue&type=template&id=540e918b&scoped=true&"
import script from "./PageCreateEdit.vue?vue&type=script&lang=js&"
export * from "./PageCreateEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540e918b",
  null
  
)

export default component.exports